import Color from 'color';
import { DEFAULT_BG_COLOR } from '../constants';
export const colorToBgColor = (color, theme) => {
    if (!color) {
        return DEFAULT_BG_COLOR;
    }
    let colorValue = color;
    if (theme) {
        const colorKeys = Object.keys(theme.colors);
        colorValue = (colorKeys.includes(color) ? theme.colors[color] : color);
    }
    try {
        return Color(colorValue).alpha(0.1).rgb().string();
    }
    catch (_a) {
        return DEFAULT_BG_COLOR;
    }
};
//# sourceMappingURL=colorToBgColor.js.map